import { SmartLink } from "../components/common/SmartLink";
import { useDocumentMeta } from "../lib/useDocumentMeta";

export function NewsArticlePage() {
  useDocumentMeta({
    canonicalPath: "/news/rapid-factory-ownership",
    description:
      "Official Holocron Security statement clarifying ownership of the RAPID Factory platform and associated patent filings.",
    title: "RAPID Factory Ownership Clarification | Holocron Security"
  });

  return (
    <article className="page-section article-shell">
      <p className="page-eyebrow">News</p>
      <h1 className="article-title">RAPID Factory Ownership Clarification</h1>
      <p className="article-lead">
        Official statement reinforcing Holocron Security&apos;s exclusive ownership of the RAPID Factory platform,
        patent filings, and trademarks.
      </p>

      <div className="content-panel article-panel">
        <div className="stack-copy">
          <p>
            Holocron Security, Inc. is the sole owner and patent holder of RAPID Factory, an agentic DevSecOps and
            infrastructure automation platform for secure-by-design, compliance-aligned deployments.
          </p>
          <p>
            RAPID Factory is part of Holocron Security&apos;s product suite alongside KyberDocs and supporting automation
            services. All associated intellectual property remains under Holocron Security ownership.
          </p>
          <div className="statement-block">
            <p>Patent reference:</p>
            <p>Hybrid Cognitive Agentic Platform for Autonomous Secure-by-Design Multi-Cloud Infrastructure Validation and Deployment.</p>
          </div>
          <p>
            Any reference or claim linking RAPID Factory to other entities is inaccurate. For verification or media
            inquiries, contact <SmartLink className="inline-link" href="mailto:info@holocronsecurity.com">info@holocronsecurity.com</SmartLink>.
          </p>
        </div>
      </div>
    </article>
  );
}
